import { appConfig } from '@box-configs/app.config';
import { environment } from '@box-env/environment';
import { GetTextByKeyType } from '@box-types';

export {
  generateTitleContent,
  generateDescriptionContent,
  generateKeywordsContent,
  generateImageContent,
  generateUrlContent,
  addNoIndexNoFollow,
  isSeoLocationPage,
  determinePathBasedOnPage,
  isSeoLocationResaurantsPage,
  isSeoLocationGroceriesPage,
  isSeoLocationHomePage,
  getSeoLocationKey,
  extractPathAndQuery
};

function generateTitleContent(title?: string): string {
  const appName = appConfig.name;
  const givenTitle = title ?? 'Online Delivery';
  return `${givenTitle} | ${appName}`;
}

function generateDescriptionContent(description: string, translateFn: GetTextByKeyType): string {
  return translateFn(description) ?? translateFn('seo_default_description');
}

function generateKeywordsContent(keywords: string, translateFn: GetTextByKeyType): string {
  return translateFn(keywords) ?? translateFn('seo_default_keywords');
}

function generateImageContent(url?: string): string {
  const ROOT_URL = environment.application.ROOT_URL;
  return url ?? `${ROOT_URL}/assets/images/box-share-image.png`;
}

function generateUrlContent(routerUrl?: string): string {
  const ROOT_URL = environment.application.ROOT_URL;
  return routerUrl ? `${ROOT_URL}${routerUrl}` : ROOT_URL;
}

function addNoIndexNoFollow() {
  if (!document) return;
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex, nofollow';
  document.head.appendChild(meta);
}

function isSeoLocationPage(path: string): boolean {
  if (!path) return false;
  if (isSeoLocationResaurantsPage(path) || isSeoLocationGroceriesPage(path) || isSeoLocationHomePage(path)) return true;
  return false;
}

function isSeoLocationResaurantsPage(path: string): boolean {
  const pathLength = path.split('/').length;
  if (path.includes('/delivery/') && path.includes('/estiatoria') && pathLength === 4) return true;
  return false;
}

function isSeoLocationGroceriesPage(path: string): boolean {
  const pathLength = path.split('/').length;
  if (path.includes('/delivery/') && path.includes('/psonia') && pathLength === 4) return true;
  return false;
}

function isSeoLocationHomePage(path: string): boolean {
  const pathLength = path.split('/').length;
  if (path.includes('/delivery/') && pathLength === 3) return true;
  return false;
}

function getSeoLocationKey(path: string): string {
  if (!isSeoLocationPage(path)) return;
  const segments = path.split('/');
  const segmentsLength = segments?.length ?? 0;
  if (segmentsLength < 2) return;
  return segments[2];
}

function determinePathBasedOnPage(path: string, endUrlParam?: string): string {
  const isSeoLP = isSeoLocationPage(path);
  const locationPath = path.split('/')[2];
  if (endUrlParam) {
    return isSeoLP ? '/delivery/' + locationPath + endUrlParam : '/discover';
  } else {
    return isSeoLP ? '/delivery/' + locationPath : '/discover';
  }
}

function extractPathAndQuery(action: string): { path: string; query: Record<string, string> } {
  // Reject clearly invalid inputs
  if (!action.startsWith('/') && !/^https?:\/\//.test(action)) {
    throw new Error(`Invalid URL: ${action}`);
  }

  const actionUrl = new URL(action, window.location.origin);
  const path = actionUrl.pathname;
  const searchParams = actionUrl.searchParams;

  const query: Record<string, string> = {};
  searchParams.forEach((value, key) => {
    query[key] = value;
  });

  return { path, query };
}
